import React, { Fragment, useEffect, useState } from 'react';
import {
    Row,
    Col,
    Card,
    CardTitle,
    CardBody,
    Button,
    Input,
    CustomInput,
    Label,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import {
    AxiosAPI,
    getGroupID,
    getUserID,
} from '../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
    API_External_Source,
    API_Ingetration_Channels,
    gAPI_Users_By_Id,
    API_Sync_SABRE,
} from '../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import sync_sabre from '../../../../../assets/sync_aven.png';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';

const SynXisForm = ({
    propertyId,
    email,
    locale,
    submit,
    LoadData,
    hotelCode,
    synxisData,
    propertyLanguages,
    sabreIntegration,
    clickEnd,
    isSuccess,
    setIsSuccess,
}) => {
    const [languageOptions, setLanguageOptions] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [sourceData, setSourceData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        createdBy: 'Admin',
        sourceStatus: 'Active',
        sourceType: 'SynXis',
        name: 'SynXis CRS Sync',
        frequency: 'Weekly',
        webPages: [],
        faqList: [],
        synXisConfiguration: {
            guestRooms: false,
            generalText: false,
            propertyDescription: false,
            policies: false,
            contactInfo: false,
            locationInfo: false,
        },
        enableFAQ: false,
        email: email,
    });
    useEffect(() => {
        if (synxisData?.id) {
            AxiosAPI({
                method: 'get',
                url: `${API_External_Source}/${synxisData.id}`,
            }).then((res) => {
                const data = res.data;
                if (data.synXisConfiguration === null) {
                    data.synXisConfiguration = {
                        guestRooms: false,
                        generalText: false,
                        propertyDescription: false,
                        policies: false,
                        contactInfo: false,
                        locationInfo: false,
                        ratePlans: false,
                        languages: [],
                    };
                }
                let lst = [];
                let selectedList = [];
                if (propertyLanguages != undefined && propertyLanguages.length > 0) {
                    propertyLanguages.map((m) =>
                        lst.push({ key: m, value: m, label: m })
                    );
                    propertyLanguages
                        .filter(
                            (f) =>
                                data.synXisConfiguration.languages.length > 0 &&
                                data.synXisConfiguration.languages.filter((l) => l == f)
                                    .length > 0
                        )
                        .map((m) => selectedList.push({ key: m, value: m, label: m }));
                }
                setSelectedLanguages(selectedList);
                setLanguageOptions(lst);
                setSourceData({
                    ...data,
                    name: 'SynXis CRS Sync',
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    createdBy: 'Admin',
                    email: email,
                });
            });
        } else {
            let lst = [];
            if (propertyLanguages != undefined && propertyLanguages.length > 0)
                propertyLanguages.map((m) => lst.push({ key: m, value: m, label: m }));
            setLanguageOptions(lst);
        }
    }, [propertyId, synxisData]);


    const handleSynXisConfiguration = (e) => {
        let configuration = { ...sourceData.synXisConfiguration };
        configuration[e.target.name] = e.target.checked;
        setSourceData({ ...sourceData, synXisConfiguration: configuration });
    };

    const handleChange = (e) => {
        setSourceData({ ...sourceData, [e.target.name]: e.target.value });
    };

    const handleSyncManualy = (item) => {
        handleSabre(item);
    };
    const handleSabre = (item) => {
        AxiosAPI({
            method: 'get',
            url: `${API_External_Source}/${item?.id}`,
        })
            .then((res) => {
                const upload = {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    integrationId: sabreIntegration?.id,
                    guestRooms: res.data?.synXisConfiguration?.guestRooms,
                    languageCode: locale,
                    hotelCode: hotelCode,
                    contactInfo: res.data?.synXisConfiguration?.contactInfo,
                    locationInfo: res.data?.synXisConfiguration?.locationInfo,
                    policies: res.data?.synXisConfiguration?.policies,
                    ratePlans: res.data?.synXisConfiguration?.ratePlans,
                    propertyDescription:
                        res.data?.synXisConfiguration?.propertyDescription,
                    languages: res.data?.synXisConfiguration?.languages,
                };
                AxiosAPI({
                    method: 'post',
                    url: `${API_Sync_SABRE}`,
                    data: upload,
                }).then((res) => {
                    NotificationManager.success(
                        '',
                        'The Import process has been initiated. Check Details in about 15 minutes.',
                        3000,
                        null,
                        null,
                        'success'
                    );
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                });
            })
            .catch((err) => console.log('err', err));
    };

    const handleSave = () => {
        const data = {
            ...sourceData,
            name: 'SynXis CRS Sync',
            groupId: getGroupID(),
            propertyId: propertyId,
            createdBy: 'Admin',
            email: email,
        };

        if (sourceData?.id) {
            AxiosAPI({
                method: 'put',
                url: `${API_External_Source}/${sourceData.id}`,
                data: data,
            })
                .then((res) => {
                    NotificationManager.success('Updated successfully', '', 3000);
                    LoadData();
                })
                .catch((err) => {
                    NotificationManager.error('Update failed', '', 3000);
                    console.error(err);
                });
        } else {
            submit(sourceData);
        }
    };

    const handleSelect = (selectedOption) => {
        setSelectedLanguages(selectedOption);
        let configuration = { ...sourceData.synXisConfiguration };
        configuration['languages'] = selectedOption.map((m) => m.value);
        setSourceData({ ...sourceData, synXisConfiguration: configuration });
    };
    return (
        <Fragment>
            <Row className="mt-2  mr-4">
                <Colxx sm={12} className="">

                    <img
                        src={sync_sabre}
                    // style={{ width: '100%', height: '90px' }}
                    ></img>
                    <Col md="12" className="mt-2 mb-3">
                        <Row>
                            {/* <Colxx sm={4} className="mb-3">
                    <Label>
                      <IntlMessages id='dashboards.title' /> <span style={{ color: 'red' }}> *</span>
                    </Label>
                    <Input
                      value={sourceData.name}
                      name="name"
                      onChange={handleChange}
                      disabled
                    ></Input>
                  </Colxx> */}
                            <Colxx sm={4} className="mb-3">
                                <Label>
                                    <IntlMessages id="pages.status" />{' '}
                                    <span style={{ color: 'red' }}> *</span>
                                </Label>
                                <Input className=' input_sty'
                                    type="select"
                                    value={sourceData.status}
                                    name="status"
                                    onChange={handleChange}
                                >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </Input>
                            </Colxx>
                            <Colxx sm={5} className="mb-3">
                                <Label>
                                    <IntlMessages id="dashboards.frequency" />{' '}
                                    <span style={{ color: 'red' }}> *</span>
                                </Label>
                                <Input className=' input_sty'
                                    type="select"
                                    value={sourceData.frequency}
                                    name="frequency"
                                    onChange={handleChange}
                                >
                                    {/* <option value="Daily">Daily</option> */}
                                    <option value="Weekly">Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Manually">Manually</option>
                                </Input>
                            </Colxx>
                        </Row>
                        <p className="mb-2">
                            With integration to SynXis, you can sync hotel description
                            using Channel Connect API's, along with rooms types from
                            SynXis CR.
                        </p>
                        <p className="mb-2">
                            All the imported data is then readily available to train the
                            AI model for AI Chatbot, AI Voice, Email, and Agent Assist.
                            Includes:
                        </p>
                    </Col>
                    <Row className="ml-1">
                        <Colxx md={5} className="mb-3">
                            <CustomInput
                                style={{ height: '2.5rem' }}
                                type="checkbox"
                                name="guestRooms"
                                checked={
                                    sourceData?.synXisConfiguration?.guestRooms ? true : false
                                }
                                label="Room Types & Description"
                                placeholder="https://www.yourwebpage1.com"
                                onChange={(e) => handleSynXisConfiguration(e)}
                            />
                        </Colxx>
                    </Row>
                    {sourceData?.synXisConfiguration?.guestRooms === true && (
                        <Row className="ml-1">
                            <Colxx md={6} className="mb-3">
                                <Select
                                    components={{ Input: CustomSelectInput }}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isMulti={true}
                                    name="form-field-name"
                                    value={selectedLanguages}
                                    onChange={handleSelect}
                                    options={languageOptions}
                                />
                            </Colxx>
                        </Row>
                    )}
                    <Row className="ml-1">
                        <Colxx md={5} className="mb-3">
                            <CustomInput
                                style={{ height: '2.5rem' }}
                                type="checkbox"
                                name="propertyDescription"
                                checked={
                                    sourceData?.synXisConfiguration?.propertyDescription
                                        ? true
                                        : false
                                }
                                label="Property Description & Amenities"
                                onChange={(e) => handleSynXisConfiguration(e)}
                            />
                        </Colxx>
                    </Row>
                    <Row className="ml-1">
                        <Colxx md={5} className="mb-3">
                            <CustomInput
                                style={{ height: '2.5rem' }}
                                name="contactInfo"
                                type="checkbox"
                                checked={
                                    sourceData?.synXisConfiguration?.contactInfo
                                        ? true
                                        : false
                                }
                                label="Contact Details"
                                onChange={(e) => handleSynXisConfiguration(e)}
                            />
                        </Colxx>
                    </Row>
                    <Row className="ml-1">
                        <Colxx md={5} className="mb-3">
                            <CustomInput
                                style={{ height: '2.5rem' }}
                                type="checkbox"
                                name="locationInfo"
                                checked={
                                    sourceData?.synXisConfiguration?.locationInfo
                                        ? true
                                        : false
                                }
                                label="Location"
                                onChange={(e) => handleSynXisConfiguration(e)}
                            />
                        </Colxx>
                    </Row>
                    <Row className="ml-1">
                        <Colxx md={12} className="mb-3">
                            <CustomInput
                                style={{ height: '2.5rem' }}
                                type="checkbox"
                                name="policies"
                                checked={
                                    sourceData?.synXisConfiguration?.policies ? true : false
                                }
                                label="Policies"
                                onChange={(e) => handleSynXisConfiguration(e)}
                            />
                        </Colxx>
                        <Colxx md={12} className="mb-3">
                            <CustomInput
                                style={{ height: '2.5rem' }}
                                type="checkbox"
                                name="ratePlans"
                                checked={
                                    sourceData?.synXisConfiguration?.ratePlans ? true : false
                                }
                                label="Rate Plans"
                                onChange={(e) => handleSynXisConfiguration(e)}
                            />
                        </Colxx>
                        <Colxx md={12}>
                            <p className="mb-2">
                                Save time and ensure accuracy by importing data from SynXis
                                CR.
                            </p>
                        </Colxx>
                        <Colxx md={12} className="mb-3 ml-4">
                            <ul className="mb-3">
                                <li>You can reimport the data anytime </li>
                                <li>All content updates are logged</li>
                            </ul>
                        </Colxx>
                    </Row>
                    <Row className="ml-1">
                        <Colxx sm={12} className="text-right mt-4">
                            {isSuccess ? (
                                <Button color="primary" outline onClick={clickEnd}>
                                    Next
                                </Button>
                            ) : (
                                <div className='widget-wrap'>
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        outline
                                        onClick={() => handleSyncManualy(sourceData)}
                                    >
                                        Sync
                                    </Button>
                                    <Button
                                        color="primary"
                                        onClick={handleSave}
                                        size="sm"
                                        className="ml-2"
                                        outline
                                    >
                                        Update SynXis
                                    </Button>
                                    <h6
                                        style={{ display: 'flex' }}
                                        className="ml-4 not-now"
                                        onClick={clickEnd}
                                    >
                                        Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M60 25 H100 L90 15 M100 25 L90 35"
                                                fill="none"
                                                stroke="grey"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>

                                    </h6>
                                </div>)
                            }
                        </Colxx>
                    </Row>
                </Colxx>
            </Row >
        </Fragment >
    );
};
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, email } = settings;
    return {
        propertyId,
        locale,
        email,
    };
};

export default injectIntl(connect(mapStateToProps, {})(SynXisForm));
